<template>
  <div class="floating-contact" @mouseenter="showContact = true" @mouseleave="showContact = false">
    <!-- 主按钮 -->
    <div class="contact-trigger">
      <svg class="contact-icon" viewBox="0 0 24 24" width="28" height="28">
        <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" fill="currentColor"/>
      </svg>
      <span class="trigger-text">联系<br/>我们</span>
    </div>

    <!-- 弹出内容 -->
    <transition name="slide-fade">
      <div v-show="showContact" class="contact-popup">
        <div class="popup-content">
          <!-- 电话 -->
          <div class="contact-item">
            <div class="item-icon phone-icon">
              <svg viewBox="0 0 24 24" width="20" height="20">
                <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" fill="currentColor"/>
              </svg>
            </div>
            <div class="item-info">
              <div class="item-label">姜经理</div>
              <div class="item-value">18844162277</div>
            </div>
          </div>

          <div class="contact-item">
            <div class="item-icon phone-icon">
              <svg viewBox="0 0 24 24" width="20" height="20">
                <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" fill="currentColor"/>
              </svg>
            </div>
            <div class="item-info">
              <div class="item-label">吴经理</div>
              <div class="item-value">18943648307</div>
            </div>
          </div>

          <!-- 微信 -->
          <div class="contact-item">
            <div class="item-icon wechat-icon">
              <svg viewBox="0 0 24 24" width="20" height="20">
                <path d="M8.5 14.5c-3.5 0-6.5-2.5-6.5-5.5s3-5.5 6.5-5.5c3.5 0 6.5 2.5 6.5 5.5 0 .5-.1 1-.2 1.5l2.2 2.2c.3.3.3.8 0 1.1-.3.3-.8.3-1.1 0l-2-2c-.9.5-2 .7-3.1.7h-2.3zm-2-6c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zm4 0c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1z" fill="currentColor"/>
              </svg>
            </div>
            <div class="item-info">
              <div class="item-label">微信咨询</div>
              <div class="item-value">扫码添加好友</div>
            </div>
          </div>

          <!-- 二维码 -->
          <div class="qr-section">
            <div class="qr-title">微信扫码咨询</div>
            <div class="qr-codes">
              <div class="qr-item">
                <div class="qr-code">
                  <img src="@/assets/gerenwx.jpg" alt="微信二维码" />
                </div>
                <div class="qr-label">个人微信</div>
              </div>
              <div class="qr-item">
                <div class="qr-code">
                  <!-- 这里放置公众号二维码图片 -->
                  <img src="@/assets/gzhwx.jpg" alt="公众号二维码" />
                </div>
                <div class="qr-label">微信公众号</div>
              </div>
            </div>
            <div class="qr-tip">扫描二维码，立即咨询</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'FloatingContact',
  data() {
    return {
      showContact: false
    }
  }
}
</script>

<style scoped>
.floating-contact {
  position: fixed;
  right: 30px;
  bottom: 150px;
  z-index: 999;
}

.contact-trigger {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #6aa9f3 0%, #0077ff 100%);
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 119, 255, 0.3);
  transition: all 0.3s ease;
  color: white;
}

.contact-trigger:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(0, 119, 255, 0.5);
}

.contact-icon {
  margin-bottom: 2px;
}

.trigger-text {
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
  text-align: center;
}

.contact-popup {
  position: absolute;
  right: 75px;
  bottom: 0;
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  min-width: 280px;
  overflow: hidden;
}

.popup-content {
  padding: 20px;
}

.contact-item {
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
}

.contact-item:last-of-type {
  border-bottom: none;
}

.item-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;
}

.phone-icon {
  background: linear-gradient(135deg, #6aa9f3 0%, #0077ff 100%);
  color: white;
}

.wechat-icon {
  background: linear-gradient(135deg, #7dd87d 0%, #07c160 100%);
  color: white;
}

.item-info {
  flex: 1;
}

.item-label {
  font-size: 13px;
  color: #999;
  margin-bottom: 4px;
}

.item-value {
  font-size: 15px;
  color: #333;
  font-weight: 600;
}

.qr-section {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 2px dashed #e0e0e0;
  text-align: center;
}

.qr-title {
  font-size: 14px;
  color: #333;
  font-weight: 600;
  margin-bottom: 15px;
}

.qr-codes {
  display: flex;
  justify-content: space-around;
  gap: 15px;
  margin-bottom: 10px;
}

.qr-item {
  flex: 1;
  max-width: 130px;
}

.qr-code {
  width: 120px;
  height: 120px;
  margin: 0 auto 8px;
  border-radius: 8px;
  overflow: hidden;
  border: 2px solid #f0f0f0;
  transition: all 0.3s ease;
}

.qr-code:hover {
  border-color: #0077ff;
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 119, 255, 0.2);
}

.qr-code img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.qr-label {
  font-size: 12px;
  color: #666;
  font-weight: 500;
}

.qr-tip {
  font-size: 12px;
  color: #999;
}

/* 动画效果 */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.2s ease;
}

.slide-fade-enter-from {
  opacity: 0;
  transform: translateX(20px);
}

.slide-fade-leave-to {
  opacity: 0;
  transform: translateX(20px);
}

/* 响应式 */
@media (max-width: 768px) {
  .floating-contact {
    right: 15px;
    bottom: 100px;
  }

  .contact-popup {
    right: 70px;
    min-width: 260px;
  }

  .qr-codes {
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }

  .qr-item {
    max-width: 150px;
  }

  .qr-code {
    width: 130px;
    height: 130px;
  }
}
</style>
